
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/curated-sets",
      function () {
        return require("private-next-pages/d/curated-sets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/curated-sets"])
      });
    }
  